import GlobalMetricsSelections from './GlobalMetricsSelections';

export default GlobalMetricsSelections;
